module.exports = __webpack_public_path__ + "img/lsmy-ai-robot-hide.cbd772d3.png";